import React from 'react';
import {
  SearchByOtherResultItem,
  RecordedDocument,
  Lien,
  EmergencyRepair as EmergencyRepairModel,
  EnvironmentalControlBoardJudgment as EnvironmentalControlBoardJudgmentModel,
} from 'pages/Search/models';
import {
  EnvironmentalControlBoardJudgment,
  LiensListItem,
  DocumentsListItem,
  EmergencyRepairsListItem,
} from '..';
import { Col, Empty, Row, Typography } from 'antd';
import { BasicTable } from 'common';
import { Tabs } from 'pages/Search/SearchForm/consts';
import SearchSelectAll from 'pages/Search/SearchSelectAll/SearchSelectAll';
import { ResultTypeName } from 'pages/Search';

const { Text } = Typography;

const SearchByOtherResultTable: React.FC<{
  result: SearchByOtherResultItem;
  tabName: Tabs;
  searchId: number;
  resultType?: ResultTypeName;
}> = (props: {
  result: SearchByOtherResultItem;
  tabName: Tabs;
  searchId: number;
  resultType?: ResultTypeName;
}) => {
  const { result, tabName, searchId, resultType } = props;
  const { items, searchBy } = result;
  const selected = items.filter((item) => item.isSelected).length;
  const count = items.length;
  const resultsNoun = count === 1 ? 'result' : 'results';

  return (
    <>
      <Row type="flex" justify="end">
        <Col>
          <SearchSelectAll
            selected={selected}
            count={count}
            resultItemIndex={result.index}
            documentType={searchBy}
            tabName={tabName}
            resultType={resultType}
          />
        </Col>
      </Row>
      <Text>
        Your search has returned {count} {resultsNoun} ({selected} selected for
        print/export)
      </Text>
      {count > 0 ? (
        <BasicTable
          items={items}
          renderRow={(
            text: string,
            record:
              | RecordedDocument
              | Lien
              | EnvironmentalControlBoardJudgmentModel
              | EmergencyRepairModel,
            index: number,
          ) => {
            if ((record as Lien).lienId)
              return (
                <LiensListItem
                  searchId={searchId}
                  lien={record as Lien}
                  index={index}
                  resultType={resultType}
                  resultItemIndex={result.index}
                />
              );
            if ((record as RecordedDocument).documentID)
              return (
                <DocumentsListItem
                  document={record as RecordedDocument}
                  index={index}
                  resultType={resultType}
                  resultItemIndex={result.index}
                />
              );
            if ((record as EmergencyRepairModel).fileNumber)
              return (
                <EmergencyRepairsListItem
                  er={record as EmergencyRepairModel}
                  index={index}
                  resultType={resultType}
                  resultItemIndex={result.index}
                />
              );
            if (
              (record as EnvironmentalControlBoardJudgmentModel).violationNumber
            )
              return (
                <EnvironmentalControlBoardJudgment
                  judgment={record as EnvironmentalControlBoardJudgmentModel}
                  index={index}
                  resultType={resultType}
                  resultItemIndex={result.index}
                />
              );
          }}
        />
      ) : (
        <Empty
          description={`Your search has returned ${count} ${resultsNoun}`}
        />
      )}
    </>
  );
};

export default SearchByOtherResultTable;
